import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './ModalHeading';
import { EditBlock } from '../containers/Workouts';
export default class EditBlockButton extends Component {

	state = {
		open: false
	};

	hideModal = () => {
		this.props.onClose();
	}

	render() {

    const { block, isOpen } = this.props;
   
		return (
			<div>
	    	<Modal
	        className="modal show"
	        open={isOpen}
	        onClose={ () => this.hideModal()}>
	        <div className="modalBody modal-content" style={{width:1050}}>
						<ModalHeading
							text={(
								<div>
									<FontAwesomeIcon icon="edit"
										style={{marginRight: 5, color: COLORS.orange}}/>
									<span>{block.name}</span>
								</div>

							)}
							closeModal={() => this.hideModal() }/>
						<div className="modalContent">
							<EditBlock editId={block._id} hideNavigationTabs={true}   />
						</div>
	        </div>
	      </Modal>
			</div>
    );
	}
}



// WEBPACK FOOTER //
// ./src/components/EditBlockButton.js